import ITableHeader from "@/interfaces/ITableHeader";

/** En-tête de tableau */
class TableHeader implements ITableHeader {
	Name!: string;
	Label!: string;
}

export default TableHeader;